import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './assets/css/index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { SurveyApp, resolveSurveyRoute } from './surveys';

// The public survey (survey subdomain, or /survey/*) runs on its own, before the app's
// router, locale rewrite and session handling. See src/surveys/README.md.
const surveyRoute = resolveSurveyRoute(window.location);

ReactDOM.render(
    surveyRoute ? (
        <React.StrictMode>
            <SurveyApp route={surveyRoute} />
        </React.StrictMode>
    ) : (
        <BrowserRouter>
            <React.StrictMode>
                <App />
            </React.StrictMode>
        </BrowserRouter>
    ),
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
